<template>
  <div
    class="bg-white rounded-xl space-y-6 p-6 ml-3 relative"
  >
    <loading :active="showData"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="w-64 rounded-md text-center text-white px-6 py-1 cursor-pointer" style="background-color: #2196F3;" @click="createCustTemplate">
      <i class="pi pi-plus mr-2" style="font-size: 0.8rem;"></i>
      新增行銷活動
    </div>
    <div v-show="tempListData.length > 0" class="w-full overflow-x-hidden overflow-y-auto scrollbar grid 2xl:grid-cols-6 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4" :style="tempListData.length > 0 ? { maxHeight: '450px' } : null">
      <template v-for="(item, index) in tempListData" :key="item.index">
        <div class="w-60 border px-3 pb-3 rounded-md" style="box-shadow: 6px 6px 10px -5px #0005; height:211px;">
          <div class="w-full h-6 relative">
            <div v-if="item.use_do_forward" class="absolute bg-blue-500 text-gray-50 rounded-b-md text-xs text-center px-2 py-0.5 right-10">
              使用前進模式
            </div>
            <div class="absolute bg-gray-200 text-gray-500 rounded-b-md text-xs text-center px-2 py-0.5 right-0">
              範本
            </div>
          </div>
          <div class="font-bold break-all" v-tooltip.top="`${item.title}`">{{item.titleShort}}</div>
          <div class="h-24 text-gray-500 text-sm my-3 overflow-y-auto scrollbar">
            <template v-for="(sub_item, sub_index) in item.sub" :key="sub_item.sub_index">
              <div class="rounded-md border p-1 mr-1 my-1">
                <template v-for="(item_value, item_index) in sub_item" :key="item_value.item_index">
                  <div>
                    <!-- <span v-if="item_value.stage != ''" class="stage">階段{{item_value.stage}}</span> -->
                    <span class="line-container-before"></span>
                    <span class="flex interest items-center">
                      <span v-html="item_value.source"></span>
                      {{item_value.title}}
                      <span v-if="item_value.use_forward === true" class="text-sm font-bold text-blue-500 ml-auto" v-tooltip.top="'為前進條件'"> → </span>
                    </span>
                  </div>
                </template>
              </div>
            </template>
            <!-- <template v-for="(sub_item, sub_index) in item.sub" :key="sub_item.sub_index">
              <div class="line-container py-0.5">
                <span v-if="sub_item.stage != ''" class="stage">階段{{sub_item.stage}}</span>
                <span class="line-container-before"></span>
                <span class="flex interest">
                  <span v-html="sub_item.source"></span>
                  {{sub_item.title}}
                </span>
              </div>
            </template> -->
          </div>
          <div class="grid grid-cols-6">
            <div class="bg-gray-100 rounded-md p-1.5 w-6 cursor-pointer" v-tooltip.bottom="'刪除範本'" @click="deleteStrategy(item.id, item.title)">
              <svg width="14" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4.4165H14.668" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.12549 7.83447V12.96" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.5437 7.83447V12.96" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1.85547 4.4165L2.70972 14.6675C2.70972 15.1206 2.88972 15.5552 3.21012 15.8756C3.53053 16.196 3.96509 16.376 4.41821 16.376H11.2522C11.7053 16.376 12.1399 16.196 12.4603 15.8756C12.7807 15.5552 12.9607 15.1206 12.9607 14.6675L13.8149 4.4165" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.27173 4.41699V1.85425C5.27173 1.62769 5.36173 1.41041 5.52193 1.2502C5.68213 1.09 5.89942 1 6.12598 1H9.54297C9.76953 1 9.98681 1.09 10.147 1.2502C10.3072 1.41041 10.3972 1.62769 10.3972 1.85425V4.41699" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="bg-gray-100 rounded-md p-1.5 w-6 cursor-pointer" v-tooltip.bottom="'修改範本'" @click="editStrategy(item.id)">
              <svg class="lg:block md:block hidden" width="15" height="15" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.45872 4.67432H2.78349C2.31048 4.67432 1.85684 4.86222 1.52237 5.19669C1.1879 5.53116 1 5.98479 1 6.4578V14.4835C1 14.9565 1.1879 15.4101 1.52237 15.7446C1.85684 16.0791 2.31048 16.267 2.78349 16.267H10.8092C11.2822 16.267 11.7358 16.0791 12.0703 15.7446C12.4048 15.4101 12.5927 14.9565 12.5927 14.4835V11.8083" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.46021 11.8091H8.13544L15.7153 4.22929C16.07 3.87453 16.2693 3.39338 16.2693 2.89167C16.2693 2.38997 16.07 1.90882 15.7153 1.55406C15.3605 1.1993 14.8793 1 14.3776 1C13.8759 1 13.3948 1.1993 13.04 1.55406L5.46021 9.13388V11.8091Z" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.7009 2.89355L14.3762 5.56879" stroke="#A9AEBF" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="w-36 rounded-md text-center text-sm text-white px-1 py-1 cursor-pointer col-span-4" style="background-color: #1D619F;" @click="createForStrategy(item.id)">
              <i class="pi pi-plus mr-1" style="font-size: 0.8rem;"></i>
              從範本新增
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import { ref, computed } from 'vue';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'CustTemplateList',
  components: {
    Loading
  },
  props: {
    guideStep: {
      type: Number,
      default: -1
    },
    title: {
      type: String,
      default: 'xxx'
    },
    adAccountId: {
      type: String,
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      showData: false,
      metaAccountId: null,
      tiktokAccountId: null,
      tempListData: [],
    };
  },
  watch:{
    'adAccountId': function(v){
    //  console.log('watch adAccountId');
    //  console.log(v);

      let hash = this.$route.params.id;
      let _tmpAdAccount = v.split('___');

      this.metaAccountId = _tmpAdAccount[0];
      this.tiktokAccountId = _tmpAdAccount[1];

      this.showData = true;

      axios
        .post('https://www.autoturn.net/api/customize/strategy_list.php', Qs.stringify({
          s_code: hash,
          adaccount_id: v,
        }))
        .then((caResponse) => {
        //  console.log('caResponse:'+caResponse.data.return_data);
          if(caResponse.data.status == 'success'){
            this.tempListData = caResponse.data.return_data
          }

          this.showData = false;
        });
    },
  },
  methods: {
    createCustTemplate(){
    //  console.log('createCustTemplate');
      let member_hash = this.$route.params.id
      let adaccount_id = this.metaAccountId+'___'+this.tiktokAccountId;//this.$route.params.adaccount_id

    //  console.log(adaccount_id);
    //  console.log("https://private.autoturn.net/customize-event-add/"+this.$route.params.type+"/"+this.$route.params.id+"/"+adaccount_id);

      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: 'add',
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['views']['List']['methods']['createCampaign']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/customize-events-list/"+this.$route.params.type+"/"+member_hash+"/"+adaccount_id;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/customize-events-list/"+this.$route.params.type+"/"+member_hash+"/"+adaccount_id;
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['views']['List']['methods']['createCampaign']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/"+this.$route.params.type+"/"+member_hash;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/"+this.$route.params.type+"/"+member_hash;
                }
              })
            } else {
              Swal.fire(
                        this.lang['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.lang['views']['List']['methods']['createCampaign']['axios']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['views']['List']['methods']['createCampaign']['axios']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              axios
                .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  status: 'N',
                }))
                .then((adResponse) => {
                  window.location.href = "https://private.autoturn.net/customize-event-add/"+this.$route.params.type+"/"+this.$route.params.id+"/"+adaccount_id;
                });
            });
          }

          if(caResponse.data.status == 'success'){
            axios
              .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                status: 'N',
              }))
              .then((adResponse) => {
                window.location.href = "https://private.autoturn.net/customize-event-add/"+this.$route.params.type+"/"+this.$route.params.id+"/"+adaccount_id;
              });
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.lang['views']['List']['methods']['createCampaign']['axios']['login']['swal_title'],
              text: this.lang['views']['List']['methods']['createCampaign']['axios']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['views']['List']['methods']['createCampaign']['axios']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    deleteStrategy(id, title){
    //  console.log('createCustTemplate');
    //  console.log(id);

      let adaccount_id = this.metaAccountId+'___'+this.tiktokAccountId;//this.$route.params.adaccount_id

      if(id){
        Swal.fire({
          title: '自定義策略'+"「"+title+"」",
          html: '您要刪除此策略嗎？',
          icon: 'warning',
          showCancelButton: true,
          // width: 'auto', // 可選：根據內容自動調整寬度
          padding: '1em',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['yes_button'],
          cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['no_button'],
        }).then((result) => {
          if (result.isConfirmed) {
            axios
              .post('https://www.autoturn.net/api/customize/data/strategy_delete.php', Qs.stringify({
                s_code: this.$route.params.id,
                id: id,
              }))
              .then((adResponse) => {
                Swal.fire(
                            '自定義策略',
                            adResponse.data.info,
                            adResponse.data.status
                          )

                Swal.fire({
                  icon: adResponse.data.status,
                  title: '自定義策略',
                  text: adResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_success']['confirm_button'],
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.showData = true;

                    axios
                      .post('https://www.autoturn.net/api/customize/strategy_list.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        adaccount_id: adaccount_id,
                      }))
                      .then((caResponse) => {
                      //  console.log('caResponse:'+caResponse.data.return_data);
                        if(caResponse.data.status == 'success'){
                          this.tempListData = caResponse.data.return_data
                        }

                        this.showData = false;
                      });
                  } else if (result.isDenied) {
                    this.showData = true;

                    axios
                      .post('https://www.autoturn.net/api/customize/strategy_list.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        adaccount_id: adaccount_id,
                      }))
                      .then((caResponse) => {
                      //  console.log('caResponse:'+caResponse.data.return_data);
                        if(caResponse.data.status == 'success'){
                          this.tempListData = caResponse.data.return_data
                        }

                        this.showData = false;
                      });
                  }

                  if (result.dismiss === Swal.DismissReason.timer) {
                    this.showData = true;

                    axios
                      .post('https://www.autoturn.net/api/customize/strategy_list.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        adaccount_id: adaccount_id,
                      }))
                      .then((caResponse) => {
                      //  console.log('caResponse:'+caResponse.data.return_data);
                        if(caResponse.data.status == 'success'){
                          this.tempListData = caResponse.data.return_data
                        }

                        this.showData = false;
                      });
                  }
                });
              });
          }
        });

      } else {
        Swal.fire(
                    '自定義策略',
                    adResponse.data.info,
                    adResponse.data.status
                  )
      }
    },
    editStrategy(id){
    //  console.log('editStrategy');
    //  console.log(id);
      let adaccount_id = this.metaAccountId+'___'+this.tiktokAccountId;

      window.location.href = "https://private.autoturn.net/strategy-event/f/"+this.$route.params.id+"/"+adaccount_id+"/"+id;
    },
    createForStrategy(id){
    //  console.log('createForStrategy');
    //  console.log(id);
      let adaccount_id = this.metaAccountId+'___'+this.tiktokAccountId;

      axios
        .post('https://www.autoturn.net/api/customize/campaign/use_strategy.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: adaccount_id,
          strategy_id: id,
        }))
        .then((caResponse) => {
        //  console.log('caResponse:'+caResponse.data);
          if(caResponse.data.status == 'success'){
            window.location.href = "https://private.autoturn.net/customize-event-add/"+this.$route.params.type+"/"+this.$route.params.id+"/"+adaccount_id;
          }
        });
    }
  }
};
</script>

<style lang="css" scoped>
.panel {
  width: 48.5%;
  height: 26.7vw;
}

h5 {
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
}

@media (max-width: 1199px) {
  .panel {
    width: 100%;
    height: auto;
  }
}

.line-container {
    display: flex;
    align-items: center; /* 垂直居中對齊 */
    /*height: 40px;*/ /* 設定高度 */
    position: relative; /* 使絕對定位的元素相對於此容器 */
}

.stage {
    margin-right: 10px; /* 調整與中線之間的距離 */
}

.interest {
    margin-left: 10px; /* 調整與中線之間的距離 */
    margin-right: 10px;
}

.line-container-before {
    content: '';
    flex-grow: 1; /* 使中間的線條自動填滿空間 */
    height: 1px; /* 線條的高度 */
    background-color: #E5E7EB; /* 線條顏色 */
}
</style>
<style scoped>
@layer utilities {
  /* 滚动条的宽度 */
  .scrollbar::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* 滚动条轨道 */
  .scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* 滚动条滑块 */
  .scrollbar::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 6px;
    border: 2px solid transparent;
  }

  /* 当鼠标悬停在滚动条上时 */
  .scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
}

</style>